import { TsDOM as q } from '@/scripts/core/TsDOM'
import { type CartDrawer } from '@/scripts/cart/cart-drawer'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import {type SectionApiResponse} from "@/scripts/types/responses";

type Params = {
	productHandle: string
	variantId: number
	sellingPlanId?: number
}
export class PdpUpsellModal extends UcoastEl {
	static htmlSelector = 'pdp-upsell-modal'
	cartDrawer: CartDrawer
	params: Params | undefined
	opener?: HTMLElement // stash target el so focus can be passed to cart drawer on ATC
  dynamicContent: HTMLElement
  closeButtons: NodeListOf<HTMLButtonElement>
  atcCartResponse?: SectionApiResponse
	constructor() {
		super()
		this.cartDrawer = q.rs<CartDrawer>('cart-drawer')
    this.dynamicContent = q.rs('[data-upsell-modal="dynamic"]', this)
    this.closeButtons = q.rl('button', this)
	}

  override connectedCallback() {
    super.connectedCallback();
    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.openCart()
      })
    })
  }

  async open(params: Params, opener?: HTMLElement) {
		this.opener = opener
    this.show()
		try {
			this.params = params
			void this.loadMarkup()
      this.show()
		} catch (e) {
			this.openCart()
		}
	}
	openCart() {
    this.hide()
		this.cartDrawer.renderContents(this.atcCartResponse)
	}
  show() {
    this.classList.remove('hidden')
    this.setAttribute('aria-hidden', 'false')
    window.setTimeout(() => {
      this.classList.add('active')
    }, 1)
  }
  hide() {
    this.classList.remove('active')
    window.setTimeout(() => {
      this.classList.add('hidden')
      this.setAttribute('aria-hidden', 'true')
    }, 301)
  }

	async loadMarkup() {
    console.log('path', this.getPath())
		const res = await fetch(this.getPath())
    const markup = await res.text()
    this.dynamicContent.innerHTML = markup
    this.dynamicContent.classList.add('active')
	}
	getPath() {
		if (!this.params)
			return '/products/skincare-filter?variant=42058359472172&section_id=pdp-upsell-modal' // fallback
		const { productHandle, variantId, sellingPlanId } = this.params
		if (sellingPlanId) {
			return `/products/${productHandle}?variant=${variantId}&selling_plan=${sellingPlanId}&section_id=pdp-upsell-modal`
		}
		return `/products/${productHandle}?variant=${variantId}&section_id=pdp-upsell-modal`
	}
}
